import { StyleSheet } from 'aphrodite';
import { destructive, mention, navigation, titles } from '../../../../web/styles/colors';
import { CssSelectors, Layouts } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	body: {
		...Layouts.horizontalStack(30),
		borderBottom: '1px solid #D3DBDE',
		height: 300,
		padding: '30px 0 16px 0',
	},
	button: {
		height: 40,
		marginTop: 15,
		width: 91,
	},
	completeBy: {
		background: mention,
		display: 'flex',
		justifyContent: 'space-between',
		padding: '10px 20px 20px',
		width: 550,
		...CssSelectors.allChildren(
			{
				alignItems: 'flex-start',
			},
			'.radio-button'
		),
	},
	completeByDays: {
		textAlign: 'center',
		width: 46,
	},
	container: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
	},
	dayPicker: {
		flexShrink: 0,
		margin: 'auto',
	},
	expirationWarning: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	expirationWarningText: {
		margin: 0,
	},
	fixedWidth30: {
		display: 'inline-block',
		maxWidth: 30,
		minWidth: 30,
	},
	footer: {
		display: 'flex',
		justifyContent: 'center',
		padding: '50px 0 36px 0',
	},
	footerInputs: {
		display: 'flex',
		position: 'relative',
	},
	footerInputsInner: {
		flexGrow: 1,
		maxWidth: 600,
		...CssSelectors.allChildren(
			{
				justifyContent: 'flex-start',
			},
			'*:first-child'
		),
	},
	footerWithWarning: {
		padding: '30px 0 36px 0',
	},
	header: {
		alignItems: 'center',
		borderBottom: '1px solid #D3DBDE',
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		fontSize: 18,
		justifyContent: 'center',
		padding: '10px 0 20px 0',
	},
	headerDescription: {
		color: '#4A4A4A',
		fontSize: 14,
		marginTop: 5,
	},
	headerIcon: {
		height: 120,
		width: 120,
	},
	headerText: {
		marginLeft: 30,
		textAlign: 'left',
	},
	radio: {
		':first-child': {
			marginRight: 10,
		},
		boxSizign: 'border-box',
	},
	radioIcon: {
		paddingTop: 15,
	},
	radioLabel: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
	},
	radioLabelLeft: {
		paddingTop: 11,
	},
	selectedDayStringRep: {
		color: '#4A4A4A',
		fontSize: 14,
		marginTop: 10,
		textAlign: 'left',
		width: 160,
	},
	subText: {
		fontSize: 14,
		marginBottom: 9,
	},
	successContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 200,
	},
	successMessage: {
		fontSize: 18,
		marginBottom: 24,
		marginTop: 20,
	},
	timeDropdown: {
		...CssSelectors.allChildren(
			{
				maxWidth: 150,
				minWidth: 120,
			},
			'.select-box-menu'
		),
	},
	timeDropdownOption: {
		fontSize: 14,
	},
	timeDropdownPlaceholder: {
		color: navigation,
	},
	timeDropdownTrigger: {
		fontSize: 14,
		height: 'auto',
		minWidth: 108,
	},
	warningMessage: {
		background: '#FFFCFD',
		border: `1px solid ${destructive}`,
		borderRadius: 20,
		color: '#4A4A4A',
		fontSize: 14,
		marginBottom: 20,
		marginLeft: 'auto',
		marginRight: 'auto',
		padding: '10px 20px',
	},
});
